<template>
  <li class="mobile-last-searches hidden">
    <ul>
      <MobileMenuItem
        :item="config.item"
        :panel="true"
        :utag-event-info="{
          event_act: 'last search',
          event_lbl: 'dropdown',
        }"
        >>
        <template #panel>
          <div class="b-last-searches-cards">
            <h2 class="t-label mb-4">{{ config.item.name }}</h2>
            <div class="flex-container"></div>
            <!-- .flex-container -->
          </div>
          <!-- .b-last-searches-cards -->
        </template>
      </MobileMenuItem>
    </ul>
  </li>
</template>

<script>
import MobileMenuItem from '../MobileMenuItem/MobileMenuItem'

const componentName = 'MobileLastSearches'

export default {
  name: componentName,
  components: {
    MobileMenuItem,
  },
  props: {
    config: Object,
  },
  mounted() {
    IB.lastSearchesCards.init()
  },
}
</script>
